// extracted by css-extract-rspack-plugin
export default {"autosizeTextInputContainer":"autosize-text-input-module__autosizeTextInputContainer__uAQ6Hab"};